var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _ellipse2, _ellipse3, _ellipse4, _path7, _path8, _rect, _rect2, _path9, _ellipse5, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.96641,
    cy: 13,
    rx: 0.995216,
    ry: 1,
    fill: "white",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69005 21.6729C7.69005 23.5575 6.43965 24.0286 5.81445 24.0286C6.75225 24.0286 7.69005 25.7562 7.69005 26.3844C7.69005 25.4421 8.94045 24.0286 9.56565 24.0286C8.06517 24.0286 7.69005 22.4581 7.69005 21.6729Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5724 20.7305C39.5724 22.6151 38.322 23.0862 37.6968 23.0862C39.1973 23.0862 39.5724 24.8138 39.5724 25.442C39.5724 23.9343 40.8228 23.0862 41.448 23.0862C39.9475 23.0862 39.5724 21.5157 39.5724 20.7305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9839 11.4258L24.7591 0.562301C24.1425 0.213875 23.3876 0.217529 22.7745 0.571907L3.99926 11.4225C3.38087 11.7799 3 12.4399 3 13.1541V34.4062C3 35.1087 3.36852 35.7596 3.97082 36.1211L22.7463 47.3892C23.3737 47.7658 24.1567 47.7696 24.7877 47.3993L44.0122 36.1181C44.6241 35.759 45 35.1026 45 34.3932V13.1671C45 12.4459 44.6118 11.7806 43.9839 11.4258Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5173 14.4734L23.6369 5.42725L7.69434 14.4734V32.5657L23.6369 41.6119L40.5173 32.5657V14.4734Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.9842 11.4253L24 0.128906V47.8517L44.0117 36.1175C44.6239 35.7585 45 35.102 45 34.3922V13.1664C45 12.4453 44.6119 11.7801 43.9842 11.4253Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4289 14.7883C22.3691 12.6025 25.4682 12.6025 26.4084 14.7883C27.1458 16.5027 29.0317 17.4146 30.8336 16.9286C33.0989 16.3177 35.0198 18.6764 33.9613 20.7703L33.856 20.9787C33.0113 22.6496 33.4734 24.6851 34.9569 25.8274L35.0412 25.8924C36.9246 27.3427 36.2249 30.336 33.8946 30.8051C32.0624 31.1739 30.7621 32.811 30.8192 34.679L30.825 34.8663C30.8967 37.2128 28.1354 38.5157 26.3699 36.9684C24.967 35.7388 22.8703 35.7388 21.4674 36.9684C19.7019 38.5157 16.9406 37.2128 17.0124 34.8663L17.0181 34.679C17.0752 32.811 15.7749 31.1739 13.9428 30.8051C11.6124 30.336 10.9128 27.3427 12.7961 25.8924L12.8805 25.8274C14.3639 24.6851 14.8261 22.6496 13.9814 20.9787L13.876 20.7703C12.8175 18.6764 14.7384 16.3177 17.0038 16.9286C18.8057 17.4146 20.6915 16.5027 21.4289 14.7883Z",
    fill: "#E7C605"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8326,
    cy: 31,
    rx: 0.995216,
    ry: 1,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.962,
    cy: 17,
    rx: 0.995216,
    ry: 1,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.402,
    cy: 24.5,
    rx: 6.4689,
    ry: 6.5,
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8901 23L22.8279 26L20.9141 24.125",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7605 2.82715H13.4399C12.3354 2.82715 11.4399 3.72258 11.4399 4.82715V11.2092C11.4399 11.8617 11.7582 12.4731 12.2927 12.8474L22.451 19.9615C23.1157 20.427 23.9958 20.4447 24.6787 20.0063L35.841 12.8405C36.414 12.4727 36.7605 11.8385 36.7605 11.1575V4.82715C36.7605 3.72258 35.8651 2.82715 34.7605 2.82715Z",
    fill: "#414141"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.1284,
    y: 2.82715,
    width: 1.8756,
    height: 13.1923,
    fill: "#676767"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2607,
    y: 2.82715,
    width: 1.8756,
    height: 13.1923,
    fill: "#676767"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8872 13.9314C21.9256 11.5173 25.3483 11.5173 26.3867 13.9314C26.9749 15.2989 28.4808 16.0257 29.918 15.6381C32.4263 14.9617 34.5575 17.5721 33.3855 19.8906L33.2789 20.1015C32.6055 21.4335 32.9739 23.056 34.1564 23.9666L34.2444 24.0343C36.329 25.6396 35.5493 28.9539 32.97 29.4731C31.51 29.767 30.4718 31.0719 30.5174 32.5605L30.5232 32.7497C30.6026 35.3453 27.5481 36.7865 25.5952 35.0749C24.4745 34.0926 22.7994 34.0926 21.6786 35.0749C19.7257 36.7865 16.6713 35.3453 16.7507 32.7497L16.7565 32.5605C16.802 31.0719 15.7638 29.767 14.3039 29.4731C11.7245 28.9539 10.9448 25.6396 13.0295 24.0343L13.1174 23.9666C14.2999 23.056 14.6683 21.4335 13.995 20.1015L13.8883 19.8906C12.7163 17.5721 14.8476 14.9617 17.3558 15.6381C18.7931 16.0257 20.299 15.2989 20.8872 13.9314Z",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.402,
    cy: 24.5,
    rx: 6.4689,
    ry: 6.5,
    fill: "#0087D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6028 22.3019C26.9865 22.6973 26.9785 23.3305 26.585 23.716L22.828 27.3966L20.2194 24.841C19.8259 24.4555 19.8179 23.8223 20.2016 23.4269C20.5853 23.0315 21.2154 23.0235 21.6089 23.409L22.828 24.6034L25.1955 22.284C25.589 21.8985 26.2191 21.9065 26.6028 22.3019Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 42.7297,
    y1: -2.28571,
    x2: 23.8444,
    y2: 51.4736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEED6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 24.1058,
    y1: 5.42725,
    x2: 24.1058,
    y2: 41.6119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGus);
export default __webpack_public_path__ + "static/media/gus.b4fe1b4e.svg";
export { ForwardRef as ReactComponent };